var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-text',{staticClass:"pa-0"},[_c('v-data-table',{attrs:{"fixed-header":"","disable-pagination":"","hide-default-footer":"","headers":_vm.payload.data.headers,"items":_vm.payload.data.items,"height":"250px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }